module.exports = __webpack_public_path__ + "img/eyebrow_female_arched_thin_mask.1d3fbb88.png";